import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppRoutes from '@utilities/app-routes';

const NotAuthorized = () => {
	const [countdown, setCountdown] = useState(5);
	const navigate = useNavigate();

	useEffect(() => {
		const timer = setInterval(() => {
			setCountdown(prev => prev - 1);
		}, 1000);

		if (countdown === 0) {
			if (window.history.length > 2) {
				window.history.back();
			} else {
				navigate(AppRoutes.LOGIN);
			}
		}

		return () => clearInterval(timer);
	}, [countdown, navigate]);

	return (
		<div className="flex items-center justify-center min-h-screen bg-[var(--color-bg)]">
			<div className="flex flex-col items-center text-center max-w-md px-6">
				<div className="w-20 h-20 rounded-3xl bg-[var(--color-danger-light)] flex items-center justify-center mb-6">
					<i className="pi pi-lock text-3xl text-[var(--color-danger)]" />
				</div>
				<h1 className="text-2xl font-bold text-[var(--color-text-primary)] tracking-tight mb-2">
					Not Authorized
				</h1>
				<p className="text-sm text-[var(--color-text-tertiary)] mb-6">
					You don't have permission to access this page.
				</p>
				<div className="flex items-center gap-3 mb-4">
					<button
						onClick={() => {
							if (window.history.length > 2) {
								window.history.back();
							} else {
								navigate(AppRoutes.DASHBOARD);
							}
						}}
						className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-accent)] text-[var(--color-text-inverted)] rounded-xl text-sm font-medium transition-opacity hover:opacity-90 cursor-pointer border-none"
					>
						<i className="pi pi-arrow-left text-sm" />
						Go Back
					</button>
					<button
						onClick={() => navigate(AppRoutes.DASHBOARD)}
						className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-card)] text-[var(--color-text-secondary)] border border-[var(--color-border)] rounded-xl text-sm font-medium transition-colors hover:bg-[var(--color-surface)] cursor-pointer"
					>
						Dashboard
					</button>
				</div>
				<p className="text-xs text-[var(--color-text-tertiary)]">
					Redirecting in {countdown}s...
				</p>
			</div>
		</div>
	);
};

export default NotAuthorized;
